import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    root: {
        height: "auto",
        width: (props) => (props.fullWidth ? "100%" : props.wide ? 635 : 246),
        overflow: "hidden",
        [theme.breakpoints.down("sm")]: {
            width: (props) => (props.fullWidth || props.wide ? "calc(100% - 16px)" : 246 / 1.3)
        }
    }
}));
export const CardWrapper = (props) => {
    const classes = useStyles(props);
    return React.createElement("div", { className: classes.root }, props.children);
};
//# sourceMappingURL=CardWrapper.js.map